import "../assets/styles/Footer.scss";

function Footer() {
  return (
    <footer>
      <p>
        A portfolio designed & built by{" "}
        <a href="https://hazelvo.github.io" target="_blank" rel="noreferrer">
          Phi Hung Vo Hoang
        </a>{" "}
        with 💜
      </p>
    </footer>
  );
}

export default Footer;
